import { defineComponent as _defineComponent } from 'vue'
import { useConfirmDialog } from '@/composables/useConfirmDialog';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmDialog',
  setup(__props) {

const { isVisible, options, confirm, cancel } = useConfirmDialog();

return { __sfc: true,isVisible, options, confirm, cancel }
}

})